import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Main = styled.section`
  padding: 110px 0;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 85% 80%, ${(props) => props.theme.text}0f 0%, transparent 42%),
    #f6f7f9;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 24px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #0f1115;
  margin-bottom: 14px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const Sub = styled(motion.p)`
  text-align: center;
  max-width: 620px;
  margin: 0 auto 56px;
  font-size: 17px;
  line-height: 1.65;
  color: #5b6472;

  @media screen and (max-width: 768px) {
    font-size: 15px;
    margin-bottom: 40px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
`;

export const Card = styled(motion.div)`
  padding: 26px 24px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 14px 34px -26px rgba(15, 17, 21, 0.5);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 20px 46px -22px ${(props) => props.theme.text};
  }
`;

export const IconWrap = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  margin-bottom: 16px;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.text}1f;
  border: 1px solid ${(props) => props.theme.text}3a;

  svg {
    font-size: 22px;
  }
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #0f1115;
  margin-bottom: 8px;
`;

export const CardText = styled.p`
  font-size: 14.5px;
  line-height: 1.6;
  color: #6b7280;
`;
